/** Entity type identifiers — must match server <see cref="MeetingEntityTypes"/>. */
export const MeetingEntityTypes = {
    Rock: 'rock',
    Headline: 'headline',
    ToDo: 'toDo',
    HrGoal: 'hrGoal',
    RockMilestone: 'rockMilestone',
    MeetingPage: 'meetingPage',
} as const

export type MeetingEntityType = (typeof MeetingEntityTypes)[keyof typeof MeetingEntityTypes]

export interface ContentChangeNotification {
    meetingId: string
    entityType: MeetingEntityType
    operation: 'create' | 'update' | 'delete'
    entityId: string
    parentEntityId?: string | null
}

export interface WhiteboardChangeNotification {
    meetingId: string
    html: string
}
